import { useVeloraStore } from '../store/useVeloraStore';
import { THEMES } from '../lib/themes';

export function useTheme() {
  const theme = useVeloraStore(s => s.theme);
  return THEMES[theme];
}
